/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return */
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { environment } from '@environments/environment';

@Injectable()
export class EncryptingService {
    public encrypt(value: string): string {
        const key = CryptoJS.enc.Hex.parse(environment.cryptoJS.base64Key);
        const iv = CryptoJS.enc.Hex.parse(environment.cryptoJS.iv);

        const encrypted = CryptoJS.AES.encrypt(value, key, {
            iv: iv,
        });

        return encrypted.toString();
    }

    public decrypt(value: string): unknown {
        const key = CryptoJS.enc.Hex.parse(environment.cryptoJS.base64Key);
        const iv = CryptoJS.enc.Hex.parse(environment.cryptoJS.iv);

        const decrypted = CryptoJS.AES.decrypt(value, key, {
            iv: iv,
        });

        const descrString = decrypted.toString(CryptoJS.enc.Utf8);

        return JSON.parse(descrString);
    }
}
